<template>
  <div id="music" class="music-info">
    <MainStatue pgeTitle='Music' msg="Check out the latest songs on Spotify!"/>
    <section class="music-items">
      <iframe src="https://open.spotify.com/embed/artist/2KsolON28VM0XR2yY4Nhey" width="300" height="300" frameborder="0"
      allowtransparency="true" allow="encrypted-media"></iframe>
    </section>
    <BottomSection />
  </div>
</template>
<script>
import MainStatue from '@/components/MainStatue.vue';
import BottomSection from '@/components/BottomSection.vue';

export default {
  name: 'MusicInfo',
  components: {
    MainStatue,
    BottomSection,
  },
};
</script>
<style scoped>
.music-info {
  background-color: #091341;
}
.music-items {
  display: flex;
  align-items: center;
  flex-direction: column;
  transform: translateY(-400px);
}
</style>